import { render, staticRenderFns } from "./CommunityCollectionForm.vue?vue&type=template&id=1cd7c64e&"
import script from "./CommunityCollectionForm.vue?vue&type=script&lang=js&"
export * from "./CommunityCollectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports